import get from 'lodash/get';
import { createSelector } from 'reselect';

export const DEFAULTS = {
    appointmentDetails: {},
    context: {},
    preferences: {},
};

const selectContext = (state) => state.context || DEFAULTS.context;

export const getAppointmentDetails = (state) => state.appointmentDetails;

export const getAppointmentPreferences = createSelector([selectContext], (context) =>
    get(context, 'preferences.scheduleAppointmentLink', DEFAULTS.preferences)
);
export const getStoreId = (_, props) => props.storeId;

export const getStoreAppointmentData = (appointmentDetails, id = '') =>
    get(appointmentDetails, `byStoreID.${id}`, DEFAULTS.appointmentDetails);

export const selectAppointmentDetailsById = createSelector(
    getAppointmentDetails,
    getStoreId,
    getStoreAppointmentData
);
